







































































import type { PropType } from '@nuxtjs/composition-api';
import { computed, defineComponent } from '@nuxtjs/composition-api';
import { SfLink } from '@storefront-ui/vue';
import VaimoLink from 'atoms/VaimoLink.vue';
import { FocusTrap } from 'focus-trap-vue';

import type { TooltipProductI } from './types';

export default defineComponent({
  name: 'InstalikeTooltip',
  components: {
    SfLink,
    FocusTrap,
    VaimoLink
  },
  props: {
    tooltipProduct: {
      type: Object as PropType<TooltipProductI | null>,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  emits: ['tooltip:add-to-cart', 'tooltip:notify-me', 'tooltip:close'],
  setup(props) {
    const isSoldOut = computed<boolean>(() =>
      Boolean(
        props.tooltipProduct &&
          !props.tooltipProduct.hasStock &&
          !props.tooltipProduct.replenishable
      )
    );

    const canNotify = computed<boolean>(() =>
      Boolean(
        props.tooltipProduct &&
          !props.tooltipProduct.hasStock &&
          props.tooltipProduct.replenishable
      )
    );

    return {
      isSoldOut,
      canNotify,
      initialFocus: computed<string>(() =>
        props.tooltipProduct && !isSoldOut.value
          ? '.instalike-tooltip__link'
          : ''
      ),
      fallbackFocus: computed<string>(() =>
        props.tooltipProduct?.name ? '.instalike-tooltip__name' : ''
      )
    };
  }
});
